import React, { Component, PropTypes } from 'react'

import { getProperty, filterObject } from '../utils'
import { Loading } from '../misc'
import { Boolean } from '../ui'

export default class DroneQuestions extends Component {
    static propTypes = {
        crewType: PropTypes.string.isRequired,
        crew_uuid: PropTypes.string.isRequired,
        data: PropTypes.object.isRequired,
        gear: PropTypes.object.isRequired,
        gearActions: PropTypes.object.isRequired,
        updateValue: PropTypes.func.isRequired,
    }

    _updateValueAndSendPatchRequest = (data) => {
        this.props.updateValue(data)
        this._sendPatchRequest(data)
    }

    _sendPatchRequest = (data = this.props.data) => {
        const newData = filterObject(
            data,
            [
                'drone_wireless_video',
                'drone_faa_registered',
                'drone_licenced_pilot',
                'drone_insurance',
            ],
        )

        this.props.gearActions.patchGear(newData, this.props.crew_uuid, this.props.crewType)
    }

    render() {
        if (! this.props.data) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Additional Information
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        <Boolean
                            error={ errors.drone_wireless_video }
                            label="Do you offer wireless video?"
                            name="drone_wireless_video"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'drone_wireless_video') }
                        />
                        <Boolean
                            error={ errors.drone_faa_registered }
                            label="Are you FAA registered?"
                            name="drone_faa_registered"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'drone_faa_registered') }
                        />
                        <Boolean
                            error={ errors.drone_licenced_pilot }
                            label="Are you a licensed pilot?"
                            name="drone_licenced_pilot"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'drone_licenced_pilot') }
                        />
                        <Boolean
                            error={ errors.drone_insurance }
                            label="Do you carry special drone insurance?"
                            name="drone_insurance"
                            updateValue={ this._updateValueAndSendPatchRequest }
                            value={ getProperty(this.props.data, 'drone_insurance') }
                        />
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/drone_questions.js